export const VehiclesData = [
  {
    type: "Car/Jeep/Van",
    number: "TN24AQ4644",
    time: "09/09/2022, 16:43:48",
    tollName: "Chengalpattu",
    tarrif: 60,
  },
  {
    type: "LCV",
    number: "TN19QQ1234",
    time: "09/09/2022, 15:30:34",
    tollName: "Kappalur",
    tarrif: 75,
  },
  {
    type: "Truck/Bus",
    number: "TN24AA1234",
    time: "09/09/2022, 12:12:34",
    tollName: "Kappalur",
    tarrif: 400,
  },
  {
    type: "Heavy vehicle",
    number: "TN56BC5689",
    time: "09/09/2022, 12:12:34",
    tollName: "Chennai",
    tarrif: 600,
  },
];

export const VehicleTypes = [
  { label: "Car/Jeep/Van", value: "Car/Jeep/Van" },
  { label: "LCV", value: "LCV" },
  { label: "Truck/Bus", value: "Truck/Bus" },
  { label: "Heavy Vehicle", value: "Heavy Vehicle" },
];

export const TollNames = [
  { label: "Chengalpattu", value: "Chengalpattu" },
  { label: "Kappalar", value: "Kappalar" },
  { label: "Krishnagiri", value: "Krishnagiri" },
  { label: "Chennai", value: "Chennai" },
];
